import {
  DataGrid,
  DataGridWithCheckbox,
  DescriptionOutlinedIcon,
  NoRowsOverlay,
  type DataGridProps,
  type TablePaginationProps,
} from '@shared/components';

export type QSetDataGridProps = Pick<
  DataGridProps,
  | 'rows'
  | 'columns'
  | 'onCellClick'
  | 'loading'
  | 'onRowSelectionModelChange'
  | 'disableRowSelectionOnClick'
> &
  Pick<TablePaginationProps, 'page' | 'onPageChange' | 'onRowsPerPageChange'> & {
    total: TablePaginationProps['count'];
    pageSize: TablePaginationProps['rowsPerPage'];
    selectionModel?: string[];
  } & {
    withCheckbox?: boolean;
  };

export default function QSetDataGrid(props: Readonly<QSetDataGridProps>) {
  const {
    rows,
    columns,
    onCellClick,
    loading: isLoading,
    total: qsetTotal,
    page,
    pageSize,
    onPageChange,
    onRowsPerPageChange,
    onRowSelectionModelChange,
    withCheckbox = true,
    selectionModel,
    disableRowSelectionOnClick: shouldDisableRowSelectionOnClick = false,
  } = props;

  const DataGridComponent = withCheckbox ? DataGridWithCheckbox : DataGrid;

  const noRowsOverlay = () => (
    <NoRowsOverlay
      title='ยังไม่มีชุดข้อสอบ'
      icon={DescriptionOutlinedIcon}
      slotProps={{
        wrapper: {
          sx: { py: (theme) => theme.spacing(20) },
          disablePadding: true,
        },
        icon: {
          fontSize: 100,
        },
      }}
    />
  );

  return (
    <DataGridComponent
      rows={rows}
      columns={columns}
      onCellClick={onCellClick}
      getRowHeight={() => 'auto'}
      loading={isLoading}
      hideFooter={qsetTotal === 0}
      onRowSelectionModelChange={onRowSelectionModelChange}
      disableRowSelectionOnClick={shouldDisableRowSelectionOnClick}
      rowSelectionModel={selectionModel}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.grey[300]}`,
        '.MuiDataGrid-cell': {
          padding: theme.spacing(3),
        },
        '.MuiDataGrid-withBorderColor': {
          borderColor: theme.palette.grey[300],
        },
        '.MuiDataGrid-columnHeader': {
          padding: theme.spacing(3),
          backgroundColor: theme.palette.grey[100],
        },
        '.MuiDataGrid-columnHeaderCheckbox ': {
          padding: theme.spacing(0),
        },
        '.MuiDataGrid-cell:last-child': {
          padding: theme.spacing(1.5),
        },
        '.MuiDataGrid-cellCheckbox': {
          padding: theme.spacing(0),
        },
        '--DataGrid-overlayHeight': '312px',
      })}
      disableColumnMenu
      slotProps={{
        footer: {
          total: qsetTotal,
          pagination: {
            page,
            count: qsetTotal,
            rowsPerPage: pageSize,
            onPageChange: onPageChange,
            onRowsPerPageChange: onRowsPerPageChange,
          },
        },
      }}
      slots={{
        noRowsOverlay,
      }}
    />
  );
}
